// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Config from "../../../../../../Config.bs.js";
import * as ReactModal from "react-modal";
import * as CountryContext from "../../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as Button$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/Button.bs.js";
import * as WorkSpaceContext from "../../../../../../library/work-space/WorkSpaceContext.bs.js";
import * as PlaceOrderContext from "../../context/PlaceOrderContext.bs.js";
import * as PlaceOrderGaConfig from "../../../app/helper/PlaceOrderGaConfig.bs.js";
import * as PlaceOrderAssetsManager from "../../assets/PlaceOrderAssetsManager.bs.js";

var successimg = PlaceOrderAssetsManager.getImage("success.svg");

function ConfirmOrderSuccessModalCmp(Props) {
  var closeModal = Props.closeModal;
  var crn = Props.crn;
  var showModalOpt = Props.showModal;
  var assignManuallyOpt = Props.assignManually;
  var showModal = showModalOpt !== undefined ? showModalOpt : false;
  var assignManually = assignManuallyOpt !== undefined ? assignManuallyOpt : false;
  var workspaceDispatch = WorkSpaceContext.useWorkSpace(undefined);
  var match = PlaceOrderContext.useContext(undefined).state;
  var customerInfo = match.customerInfo;
  var match$1 = CountryContext.useContext(undefined);
  var country = match$1.country;
  var redirectUrl = Config.Env.getHostName(undefined) + "/administrators/open_orders?geo_region_id=\"\"&forwarded=\"\"&pfb_orders=\"\"";
  return React.createElement(ReactModal, {
              isOpen: showModal,
              onRequestClose: (function (param) {
                  return Curry._1(closeModal, undefined);
                }),
              overlayClassName: "modal-overlay",
              className: "order-redirect-modal",
              ariaHideApp: false,
              shouldCloseOnOverlayClick: false,
              children: React.createElement("div", {
                    className: "content"
                  }, React.createElement("img", {
                        src: successimg
                      }), React.createElement("p", {
                        className: "title"
                      }, "Your Order has been successfully placed"), React.createElement("p", {
                        className: "sub_title"
                      }, "We have sent you a SMS confirmation. Your order ID is"), React.createElement("p", {
                        className: "order_id"
                      }, crn), React.createElement("div", {
                        className: "button-container"
                      }, React.createElement(Button$Catalyst.make, {
                            text: "Close",
                            cb: (function (param) {
                                PlaceOrderGaConfig.publishEvent({
                                      category: /* ConfirmOrder */3,
                                      action: "Close Modal",
                                      label: "1_" + customerInfo.mobile,
                                      value: undefined,
                                      nonInteraction: undefined
                                    }, country);
                                return Curry._1(closeModal, undefined);
                              }),
                            className: "btn-secondary"
                          }), React.createElement(Button$Catalyst.make, {
                            text: "Proceed to order page",
                            cb: (function (param) {
                                PlaceOrderGaConfig.publishEvent({
                                      category: /* ConfirmOrder */3,
                                      action: "Proceed to Order Page",
                                      label: "1_" + customerInfo.mobile,
                                      value: undefined,
                                      nonInteraction: undefined
                                    }, country);
                                Curry._1(closeModal, undefined);
                                return Curry._2(workspaceDispatch.addTab, {
                                            TAG: /* OrderDetails */10,
                                            _0: crn,
                                            _1: undefined
                                          }, false);
                              }),
                            className: "btn-primary"
                          })), assignManually ? React.createElement("a", {
                          className: "btn-primary assign_mannual",
                          href: redirectUrl,
                          target: "_blank",
                          onClick: (function (param) {
                              PlaceOrderGaConfig.publishEvent({
                                    category: /* ConfirmOrder */3,
                                    action: "Proceed to Open / Un-Allocated Orders",
                                    label: "1_" + customerInfo.mobile,
                                    value: undefined,
                                    nonInteraction: undefined
                                  }, country);
                              return Curry._1(closeModal, undefined);
                            })
                        }, React.createElement(Button$Catalyst.make, {
                              text: "Proceed to Open / Un-Allocated Orders Orders",
                              cb: (function (param) {
                                  
                                }),
                              className: "btn-primary"
                            })) : null)
            });
}

var make = ConfirmOrderSuccessModalCmp;

export {
  successimg ,
  make ,
  
}
/* successimg Not a pure module */
